import React from "react"
import { Link } from "react-router-dom"
import logo from "../../assets/images/Pi-Network.png"
import { LuSearch } from "react-icons/lu"
import { CgMenuLeft } from "react-icons/cg";

const Header = () => {
  return (
    <header>
        <nav>
            <div>
                <Link to="/">
                    <div className="logo-container mobile-logo">
                        <img src={logo} alt="logo" />
                    </div>
                </Link>
            </div>
            <div>
                <LuSearch />
                <CgMenuLeft />
            </div>
        </nav>
    </header>
  )
}

export default Header